module.exports = "/images/vendor/flag-icon-css/flags/4x3/gw.svg?c1e88a916be1c72f688c9e488cdd4516";